import { render, staticRenderFns } from "./deduction-report.vue?vue&type=template&id=256ad29a&"
import script from "./deduction-report.vue?vue&type=script&lang=js&"
export * from "./deduction-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports